import { FC, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PlusIcon } from 'lucide-react'
import { ChatDesktopPreviewTable } from './ChatDesktopPreviewTable'
import { ChatDesktopPreviewItem } from './ChatDesktopPreviewItem'
import { PreviewEditsContext } from '../../../features/preview-edits/model/PreviewEditsContext'
import { PreviewAutocomplete } from '../../../features/preview-autocomplete'
import { ChatPreviewIconButton } from '../../preview/ChatPreviewIconButton'
import { AuthTokenFactory } from '../../../auth/AuthTokenFactory'
import styled from '@emotion/styled'

const LeftCell = styled('td')({
  '&&': {
    textAlign: 'left',
  },
})

export const ChatDesktopPreviewItems: FC = () => {
  const { t } = useTranslation()
  const [editingIndex, setEditingIndex] = useState<number | null>(null)
  const { items, adding, selectItem, removeItem, startAdding, cancelAdding, addItem, startEditingQuantity, stopEditingQuantity, updateUnit, updateQuantity, updateDate } = useContext(PreviewEditsContext)
  const isAgent = AuthTokenFactory.isAgent()

  return (
    <ChatDesktopPreviewTable>
      <thead>
        <tr>
          <th>{t('#')}</th>
          <th>{t('Description')}</th>
          <th style={{ width: 100 }}>{t('Units')}</th>
          <th style={{ width: 100 }}>{t('Quantity')}</th>
          <th>{t('Unit Price')}</th>
          <th>{t('% Discount')}</th>
          <th>{t('Subtotal')}</th>
          <th>{t('Delivery Date')}</th>
          <th style={{ width: 1 }}></th>
        </tr>
      </thead>

      <tbody>
        {items.map((item, index) => (
          <ChatDesktopPreviewItem
            key={item.type === 'added' ? `added-${index}` : item.previewItem.uuid}
            item={item}
            editing={editingIndex === index}
            onEditToggle={() => setEditingIndex(editingIndex === index ? null : index)}
            onSelect={(selection) => {
              selectItem(index, selection)
              setEditingIndex(null)
            }}
            onRemove={() => removeItem(index)}
            onStartEditingQuantity={() => startEditingQuantity(index)}
            onStopEditingQuantity={() => stopEditingQuantity(index)}
            onUnitChange={(unitIndex) => updateUnit(index, unitIndex)}
            onQuantityChange={(quantity) => updateQuantity(index, quantity)}
            isAgent={isAgent}
            onDateChange={(date) => updateDate(index, date)}
          />
        ))}

        <tr>
          <td></td>

          <LeftCell colSpan={8}>
            {adding ? (
              <PreviewAutocomplete autoFocus onCancel={cancelAdding} onSelect={addItem} />
            ) : (
              <ChatPreviewIconButton onClick={startAdding}>
                <PlusIcon size={16} /> {t('Add item')}
              </ChatPreviewIconButton>
            )}
          </LeftCell>
        </tr>
      </tbody>
    </ChatDesktopPreviewTable>
  )
}
